<template>
  <Select
    :items="statusDisponiveis"
    :selectedItem="filter.status"
    :label="filtro.name"
    :searchPlaceholder="filtro.placeholder"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :path="path"
    :fixo="filtro.fixo"
  />
</template>
<script>
import Select from '../../components/Select.vue';
export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
    initialState: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      filter: {
        status: {
          id: '',
          name: '',
        },
      },
      statusDisponiveis: this.filtro.opcoes || [],
    };
  },
  methods: {
    atualizar(status) {
      this.filter.status = status;

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.status.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.status.id
      });
    },
  },
  mounted() {
    const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
    this.$renderFiltroSelect(filtroAplicado, this.statusDisponiveis, this.filter.status);
  }
}
</script>
